import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';      // carrega a app e qualquer CSS dela
import './index.css';         // DEVE ficar por último entre CSS globais

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
